import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GenerateFormService, PerForm } from '@lbmx/per-form';
import {
  SpinnerService,
  ToastrNotificationService,
} from '@lbmx/phoenix-lib-utils';
import { BaseHttpService } from '@lbmx/web-core';
import { TranslocoService } from '@ngneat/transloco';
import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { schemaDefinition } from './reassign-options.ui';

export interface UserReassignOptions {
  reassignOption?: [];
}

export interface ReassignOptionsForm {
  fields: object;
  errorCode?: number;
}

export interface SelectedReassignOptions {
  record?: {
    ReassignOption?: number;
  };
  errorCode?: number;
}

@Component({
  selector: 'lib-reassign-options-container',
  template: ` <lib-reassign-options
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="save($event)"
  ></lib-reassign-options>`,
  styles: ['body .ui-dialog .ui-dialog-content { overflow-auto; }'],
})
export class ReassignOptionsContainerComponent implements OnInit {
  @Input() public baseUrl: string;
  @Input() public selectedReassignOptions: any;
  @Output() public closeDialog = new EventEmitter();
  @Output() public updateReassignOptions = new EventEmitter();

  public form: PerForm;
  public schemaDefinition = schemaDefinition;
  constructor(
    private http: BaseHttpService,
    private spinner: SpinnerService,
    private translocoService: TranslocoService,
    private toast: ToastrNotificationService,
    private formGenerator: GenerateFormService
  ) {}

  public ngOnInit(): void {
    this.http
      .fetchWithFqn({
        endpoint: `${this.baseUrl}` + `/reassign-options/form`,
        httpMethod: 'GET',
      })
      .pipe(
        tap(({ fields }: any) => {
          this.form = this.formGenerator.init(
            this.schemaDefinition(fields),
            this.selectedReassignOptions
          );
        }),
        catchError(() =>
          of(
            this.toast.errorNotify(
              this.translocoService.translate('MESSAGES.GENERIC_ERROR')
            )
          )
        )
      )
      .subscribe();
  }

  public save(formValues: any) {
    this.spinner.on();
    formValues.selectedMembers = this.selectedReassignOptions;

    this.http
      .fetchWithFqn({
        endpoint: `${this.baseUrl}/reassign-options`,
        httpMethod: 'POST',
        body: formValues,
      })
      .pipe(
        tap((response: any) => {
          this.toast.successNotify(
            this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE')
          );
          this.updateReassignOptions.emit();
          this.closeDialog.emit();
        }),
        catchError((error: any) => {
          if (error?.error?.errorCode === 5) {
            return of(
              this.toast.errorNotify(
                this.translocoService.translate(
                  'ANALYTICS_EXCLUSION.UNAUTHORIZED_TOAST_MESSAGE'
                )
              )
            );
          } else {
            return of(
              this.toast.errorNotify(
                this.translocoService.translate('MESSAGES.GENERIC_ERROR')
              )
            );
          }
        }),
        finalize(() => this.spinner.off())
      )
      .subscribe();
  }
}
